import React from 'react'

import { GameWithUserInformation } from 'containers/GamesBlock/types'
import { useUser } from 'containers/MainLayout/selectors'

import { LoginAndPlayButton } from './LoginAndPlayButton'
import { RealPlayButton } from './RealPlayButton'
import { RealPlayNotPermittedButton } from './RealPlayNotPermittedButton'

interface Props {
  game: GameWithUserInformation
}

export function PlayForRealButton({ game }: Props) {
  const { isLogged, isRealPlayPermitted } = useUser()

  const loginAndPlayButtonCondition = !isLogged
  const realPlayNotPermittedButtonCondition = isLogged && !isRealPlayPermitted
  const realPlayButtonCondition = isLogged && isRealPlayPermitted

  return (
    <>
      <LoginAndPlayButton
        game={game}
        condition={loginAndPlayButtonCondition}
      />
      <RealPlayNotPermittedButton condition={realPlayNotPermittedButtonCondition} />
      <RealPlayButton
        game={game}
        condition={realPlayButtonCondition}
      />
    </>
  )
}
